import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: calc(100% - 140px);
  background-color: #ffffff;
  overflow-y: hidden;

  @media(max-width: 770px) {
    height: 100vh;
  }
`;

export const ContainerItems = styled.div`
  margin-top: 2rem;
`;

export const Content = styled.div`
  overflow-y: scroll;
  height: 95%;
  width: 100%;

  @media(max-width: 770px) {
    height: 80%;
  }
`;

export const HeaderContainer = styled.div`
  width: 100%;
  padding: 0 0 20px 20px;
  background-color: white;

  @media (max-width: 770px) {
    display: none
  }
`;

export const HeaderMobileContainer = styled.div`
  @media (min-width: 770px) {
    display: none
  }
`;

export const IconLoading = styled.i`
  font-size: 16px;
  color: #000FFF;
`;

export const OrderIcon = styled.img`
  margin: -0.1rem 0.7rem 0 0;
  width: 18%;

  @media (min-width: 768px) {
    width: 10%;
    margin-top: 0.7rem;
  }

  @media (min-width: 1024px) {
    width: 7%;
    margin-top: 0.7rem;
  }
`;

export const PageTitle = styled.span`
  color: #808080;
  font-size: 20px;
  font-weight: 300;

  @media (min-width: 500px) {
    margin-top: 0.7rem;
  }
`;

export const PageTitleContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: -10px;
  padding: 0px 1rem;

  @media (min-width: 500px) {
    padding: 0px 4rem;
  }

  @media (max-width: 770px) {
    margin-top: 0px;
  }
`;
